import Modal from 'react-bootstrap/Modal';

function ModelForUSAqi(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          US AQI Guidelines
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table style={{fontSize:'.85rem'}}>
          <thead>
            <tr>
              <th>US AQI</th>
              <th>Levels of Concern</th>
              <th>Description of Air Quality</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{backgroundColor:'#9CD84E'}}>
              <td className='p-1'>Less than 50</td>
              <td className='p-1'>Good</td>
              <td className='p-1'>Air quality is satisfactory, and air pollution poses little or no risk</td>
            </tr>
            <tr style={{backgroundColor:'#FACF38'}}>
              <td className='p-1'>51 to 100</td>
              <td className='p-1'>Moderate</td>
              <td className='p-1'>Air quality is acceptable. However, there may be a risk for some people, particularly those who are unusually sensitive to air pollution.</td>
            </tr>
            <tr style={{backgroundColor:'#F99049'}}>
              <td className='p-1'>101 to 150</td>
              <td className='p-1'>Unhealthy for Sensitive Groups</td>
              <td className='p-1'>Members of sensitive groups may experience health effects. The general public is less likely to be affected.</td>
            </tr>
            <tr style={{backgroundColor:'#F65E5F', color:'#FFFFFF'}}>
              <td className='p-1'>151 to 200</td>
              <td className='p-1'>Unhealthy</td>
              <td className='p-1'>Some members of the general public may experience health effects; members of sensitive groups may experience more serious health effects.</td>
            </tr>
            <tr style={{backgroundColor:'#A070B6', color:'#FFFFFF'}}>
              <td className='p-1'>201 to 300</td>
              <td className='p-1'>Very Unhealthy</td>
              <td className='p-1'>Health alert: The risk of health effects is increased for everyone.</td>
            </tr>
            <tr style={{backgroundColor:'#A06A7B', color:'#FFFFFF'}}>
              <td className='p-1'>301 and higher</td>
              <td className='p-1'>Hazardous</td>
              <td className='p-1'>Health warning of emergency conditions: everyone is more likely to be affected.</td>
            </tr>
          </tbody>
        </table>
        <p style={{fontSize:'.8rem'}}>
           This guidance is available online at :{" "}
          <a
            href="https://www.iqair.com"
            target="_blank"
            rel="noreferrer"
          >
            https://www.iqair.com/
          </a>
        </p>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default ModelForUSAqi;